import React, { forwardRef } from "react";
import Icon from "../Icon";
import Loading from "../Loading";
import styles from "./TextInputExpandable.module.scss";

export default forwardRef(
  ({ icon, loading, disabled = false, spinHide, error, ...rest }, ref) => {
    const classes = [
      styles.input,
      loading ? styles.withLoading : "",
      error ? styles.error : "",
      spinHide ? styles.spinHide : "",
    ].join(" ");

    return (
      <div className={styles.wrap}>
        {icon && (
          <div className={styles.icon}>
            <Icon name={icon} size={20} />
          </div>
        )}
        <input disabled={disabled} className={classes} {...rest} ref={ref} />
        {loading && (
          <div className={styles.loading}>
            <Loading color="gray" size={20} />
          </div>
        )}
      </div>
    );
  }
);
